/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


  (function(h,o,u,n,d) {
    h=h[d]=h[d]||{q:[],onReady:function(c){h.q.push(c)}}
    d=o.createElement(u);d.async=1;d.src=n
    n=o.getElementsByTagName(u)[0];n.parentNode.insertBefore(d,n)
  })(window,document,'script','https://www.datadoghq-browser-agent.com/us1/v6/datadog-rum.js','DD_RUM')
  window.DD_RUM.onReady(function() {
    window.DD_RUM.init({
      clientToken: 'pub536051c7f646971eddf39542f8454b79',
      applicationId: 'f030c55a-c133-4a99-9404-e197c4275f25',
      // `site` refers to the Datadog site parameter of your organization
      // see https://docs.datadoghq.com/getting_started/site/
      site: 'datadoghq.com',
      service: 'metal-alchemist',
      env: 'prod',
      // Specify a version number to identify the deployed version of your application in Datadog
      version: '2.0.0',
      sessionSampleRate: 100,
      sessionReplaySampleRate: 50,
      defaultPrivacyLevel: 'mask-user-input',
    });
  });


document.addEventListener("DOMContentLoaded", function () {
    // Check if Datadog RUM is available
    if (window.DD_RUM) {
        window.DD_RUM.onReady(function () {
            // Ensure ShopifyAnalytics is available
            if (window.ShopifyAnalytics && window.ShopifyAnalytics.meta && window.ShopifyAnalytics.meta.page) {
                var userId = window.ShopifyAnalytics.meta.page.customer_id;
                var userName = window.ShopifyAnalytics.meta.page.customer_name;
                var userEmail = window.ShopifyAnalytics.meta.page.customer_email;
                var userPlan = window.ShopifyAnalytics.meta.page.plan;  // Or use a custom variable for the plan

                // Set user info for Datadog RUM
                window.DD_RUM.setUser({
                    id: userId,
                    name: userName,
                    email: userEmail,
                    plan: userPlan
                });
            } else {
                console.warn('Shopify Analytics data not available.');
            }
        });
    } else {
        console.warn('Datadog RUM SDK is not available.');
    }
});
